module.exports = __webpack_public_path__ + "static/img/banner.001fba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industryCenter/banner.png
// module id = NPpv
// module chunks = 44